<div class="zn-step-content-sections">
    <div class="zn-step-content-section zn-step-content-section--selected zn-full-height">
        <div class="zn-step-content-section-header">
            <div class="zn-step-content-section-header-inner-container">
                <div class="zn-step-content-section-titles">
                    <h5>{{ (localizationKeyPrefix + '.SelectedStandsTable.Title') | abpLocalization }}</h5>
                    <p>{{ (localizationKeyPrefix + '.Description') | abpLocalization }}</p>
                </div>
                <div class="zn-step-content-section-actions">
                    <zn-button type="primary" size="normal" iconLeft="bi bi-arrow-repeat" [label]="(localizationKeyPrefix + '.Action') | abpLocalization" (clicked)="onUpdateValues()" [loading]="loading()" loadingIconPosition="left"></zn-button>
                </div>
            </div>
            <hr class="zn-separator">
        </div>

        <div class="zn-step-content-section-body">
            <div class="zn-table zn-table--other-parameters">
                <div class="zn-table-scroll">
                    <table class="zn-table-element">
                        <thead>
                            <tr>
                                <th class="zn-table-icon-column"></th>
                                <th>{{ columnHeaderKeys.stand | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.cycle | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.rotation | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.area | abpLocalization }}</th>
                                <th class="zn-table-highlight">{{ columnHeaderKeys.applyHerbicide | abpLocalization }}</th>
                                <th class="zn-table-highlight zn-table-checkbox-column">{{ columnHeaderKeys.stumpCandidateToRegrowth | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.standStatus | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.landContractType | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.forestContractType | abpLocalization }}</th>
                                <th class="zn-table-highlight zn-table-checkbox-column">{{ columnHeaderKeys.applyFeller | abpLocalization }}</th>
                                <th class="zn-table-highlight">{{ columnHeaderKeys.measurementType | abpLocalization }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of rows(); track row.standName; let rowIndex = $index) {
                            <tr>
                                <td class="zn-table-icon-column">
                                    @if (hasRowError(row)) {
                                    <button
                                        class="zn-error-button"
                                        type="button"
                                        [title]="row.errorTitle || ('AbpUi::Error' | abpLocalization)"
                                        [aria-label]="columnHeaderKeys.showError"
                                        (click)="openRowError(row)"
                                    >
                                        <i class="bi bi-info-circle-fill warning-icon"></i>
                                    </button>
                                    }
                                </td>
                                <td>{{ row.standName }}</td>
                                <td>{{ row.cycleNumber }}</td>
                                <td>{{ row.rotationNumber }}</td>
                                <td>{{ row.standArea }}</td>
                                <td class="zn-table-highlight">
                                    <zn-simple-select
                                        [class.is-invalid]="isFieldInvalid(row, 'stumpApplicationId')"
                                        [options]="stumpApplicationOptions()"
                                        [(ngModel)]="row.stumpApplicationId"
                                        (ngModelChange)="onFieldChange(row, 'stumpApplicationId')"
                                    ></zn-simple-select>
                                </td>
                                <td class="zn-table-highlight zn-table-checkbox-column">
                                    <input
                                        [id]="'stump-candidate-to-regrowth-' + (row.id ?? row.standCycleRotationId ?? rowIndex)"
                                        type="checkbox"
                                        [class.invalid]="isFieldInvalid(row, 'isStumpCandidateToRegrowth')"
                                        [(ngModel)]="row.isStumpCandidateToRegrowth"
                                        (ngModelChange)="onFieldChange(row, 'isStumpCandidateToRegrowth')"
                                    />
                                </td>
                                <td>{{ row.standStatusName }}</td>
                                <td>{{ row.landContractName }}</td>
                                <td>{{ row.fomentContractName }}</td>
                                <td class="zn-table-highlight zn-table-checkbox-column">
                                    <input
                                        [id]="'apply-feller-' + (row.id ?? row.standCycleRotationId ?? rowIndex)"
                                        type="checkbox"
                                        [class.invalid]="isFieldInvalid(row, 'applyFeller')"
                                        [(ngModel)]="row.applyFeller"
                                        (ngModelChange)="onFieldChange(row, 'applyFeller')"
                                    />
                                </td>
                                <td class="zn-table-highlight">
                                    <zn-simple-select
                                        [class.is-invalid]="isFieldInvalid(row, 'measurementTypeId')"
                                        [options]="measurementTypeOptions()"
                                        [(ngModel)]="row.measurementTypeId"
                                        (ngModelChange)="onFieldChange(row, 'measurementTypeId')"
                                    ></zn-simple-select>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<abp-modal
    [visible]="hasErrors"
    (visibleChange)="onErrorModalVisibleChange($event)"
    (closed)="onErrorModalVisibleChange(false)"
    [options]="errorModalOptions"
>
    <ng-template #abpHeader>
        <div class="modal-header-title">
        <h3>{{errorTitle}}</h3>
        </div>
    </ng-template>

    <ng-template #abpBody>
        @if (selectedErrorMessages().length === 1) {
        <p>{{ selectedErrorMessages()[0] }}</p>
        } @else {
        <ul class="zn-error-list">
            @for (message of selectedErrorMessages(); track message) {
            <li>{{ message }}</li>
            }
        </ul>
        }
    </ng-template>
    <ng-template #abpFooter>
        <zn-button
            type="secondary"
            (clicked)="onErrorModalVisibleChange(false)"
            [label]="getCloseLabel()"
        ></zn-button>
    </ng-template>
</abp-modal>
